'use client'

import DefaultAlertDialog from '@/components/DefaultAlertDialog'
import { useTranslations } from 'next-intl'

type DeleteThreadConfirmModalProps = {
  open: boolean
  onCancel?: () => void
  onAction?: () => void
}

export default function DeleteThreadConfirmModal({
  open = false,
  onCancel,
  onAction,
}: DeleteThreadConfirmModalProps) {
  const t = useTranslations()
  return (
    <DefaultAlertDialog
      open={open}
      type="custom"
      title={t('delete-thread-confirm-modal.title')}
      description={t('delete-thread-confirm-modal.description')}
      cancelText={t('delete-thread-confirm-modal.cancel')}
      actionText={t('delete-thread-confirm-modal.action')}
      onCancel={onCancel}
      onAction={onAction}
      cancelButtonClassName="rounded-full px-5 py-3 border-[1.5px] border-vive-primary-20 text-vive-primary-20 buttonM-omni-styles hover:border-vive-primary-40 hover:text-vive-primary-40 active:text-vive-primary-60 active:border-vive-primary-60"
      actionButtonClassName="rounded-full px-5 py-3 text-white buttonM-omni-styles bg-[#f53232] hover:bg-[#d42a2a] active:bg-[#b32424] "
      allowOutsideInteraction={true}
    />
  )
}
